<!----
    Author: hjlee
    Description:
        탈퇴 모달
---->
<template>
  <b-modal
    v-if="configs"
    id="modal"
    ref="modalRef"
    :title="$t('secession_modal.title.secession')"
    :ok-title="$t('common.button.ok')"
    :cancel-title="$t('common.button.cancel')"
    @ok="confirm"
  >
    <div v-html="$t('secession_modal.notification.do_you_want_secession')" />
  </b-modal>
</template>

<script>
export default {
  methods: {
    confirm: function(evt) {
      this.$axios.$put('/auth/secession').then(response => {
        if (response.resultCode === 'success') {
          this.hideModal('modalRef')
          this.$toast.info(this.$t(response.message))
          if (response.data) {
            const user = window.copyObject(this.loggedInUser)
            user.sttusCode = response.data.sttusCode
            this.$store.commit('SET_USER', user)
          }
        } else {
          console.error(this.$t(response.message))
          this.$toast.error(this.$t(response.message))
        }
      })
    }
  }
}
</script>
